import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const CustomArrow = ({ className, style, onClick, direction }) => {
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  return (
    <button
      type="button"
      aria-label={direction === 'prev' ? 'Previous slide' : 'Next slide'}
      className={`${className} custom-slick-arrow`}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: isMobile ? '48px' : '56px',
        height: isMobile ? '48px' : '56px',
        borderRadius: '50%',
        position: 'absolute',
        top: isMobile ? '110px' : '50%',
        transform: isMobile ? 'none' : 'translateY(-50%)',
        left: direction === 'prev' ? (isMobile ? '12px' : '8px') : 'auto',
        right: direction === 'next' ? (isMobile ? '12px' : '8px') : 'auto',
        padding: 0,
        cursor: 'pointer',
        zIndex: 5,
        border: 'none',
        backgroundColor: '#04D9D9',
        color: '#ffffff',
        lineHeight: 1,
        boxShadow: '0 6px 18px rgba(50, 64, 97, 0.18)',
      }}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={direction === 'prev' ? faChevronLeft : faChevronRight}
        style={{ fontSize: isMobile ? '1rem' : '1.15rem' }}
      />
    </button>
  );
};

export default CustomArrow;
